<template>
  <div>
    <div class="doh">
      <div class="title">
        <h2>{{name}}部署情况</h2>
      </div>
      <div class="box" id="box" ref="box">
      </div>
    </div>
  </div>
</template>
<script>
import {getDoH} from "@/service/dashboard";

export default {
  data() {
    return {
      name: "",
      cnData:[0.40,0.50,1.43,0.77,0.80,1.53,1.07],
      usData:[0.50,0.60,1.39,0.70,0.71,1.43,0.97],
      date:["5-13","5-14","5-15","5-16","5-17","5-18","5-19"]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getDoH().then(res => {
        this.name = res.name;
        this.cnData = res.data.map(item => item.cn * 1000 / 10);
        this.usData = res.data.map(item => item.us * 1000 / 10);
        // this.date = res.data.map(item => item.date);
        this.date = [];
        // 遍历原始数据数组
        res.data.forEach(item => {
          // 提取月和日部分，并格式化为 "MM-DD"
          let formattedDate = item.date.substring(4, 6) + "-" + item.date.substring(6, 8);
          // 将格式化后的日期字符串添加到新数组中

          this.date.push(formattedDate);
        });
        // this.option.xAxis.data = this.date;
        this.getBar();  //获取柱状图
      });

    },
    getBar() {
      //let ec = this.$echarts.init(document.getElementById('box'))
      let ec = this.$echarts.init(this.$refs.box);

      let option = {
        tooltip: { trigger: "axis" },
        grid: {
          top: "8%",
          bottom: "8%",
          left: "0%",
          right: "6%",
          containLabel: true
        },
        xAxis:{
          type:"category",
          data:this.date,
          //两边贴紧边缘
          boundaryGap:false,
          axisLine: {
            lineStyle: { color:"rgba(170, 173, 235, 1)", width:1}
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "rgba(255, 255, 255, 1)",
            fontSize: 10,
            margin: 15
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "rgba(170, 173, 235, 1)"
            }
          }
        },
        yAxis:{
          type:"value",
          //y轴起点不为0  当data的数据过于相近的时候
          scale:true,
          // interval:0.5,
          // max: 2,
          // min: 0,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "rgba(170, 173, 235, 1)"
            }
          },
          axisLabel: {
            color: "#fff",
            fontSize: 10,
            margin: 10
          }

        },
        series:[
          {
            name:"美",
            type:"line",  //bar 柱状图 line 折线图
            showSymbol: false,
            data:this.usData,
            //折线样式
            lineStyle: {
              width: 3,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: "rgba(95, 246, 219, 1)" // 0% 处的颜色
                },
                {
                  offset: 1, color: "rgba(58, 184, 192, 1)" // 100% 处的颜色
                }]
              },
              shadowBlur: 4,
              shadowColor: "rgba(58, 184, 192, 0.2)",
              shadowOffsetY: 4
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: "rgba(58, 184, 192, 0.7)" // 0% 处的颜色
                  }, {
                    offset: 1, color: "rgba(90, 92, 116, 0.07)" // 100% 处的颜色
                  }]
                }
              }
            },
            smooth: true //平滑曲线
          },
          {
            name:"中",
            type:"line",  //bar 柱状图 line 折线图
            // z: 3, //显不显示点
            showSymbol: false,
            data:this.cnData,
            // stack:"aa",  //堆叠图 只要每个图片 有相同的stack 数据就能堆叠到一起
            //折线样式
            lineStyle: {
              width: 3,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: "rgba(67, 86, 255, 1)" // 0% 处的颜色
                }, {
                  offset: 1, color: "rgba(93, 150, 255, 1)" // 100% 处的颜色
                }]
              },
              shadowBlur: 4,
              shadowColor: "rgba(93, 150, 255,.2)",
              shadowOffsetY: 4
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: "rgba(93, 150, 255, 0.8)" // 0% 处的颜色
                  }, {
                    offset: 1, color: "rgba(163, 173, 255, 0.1)" // 100% 处的颜色
                  }]
                }
              }
            },
            smooth: true //平滑曲线
          }

        ]

      };

      ec.setOption(option);
      window.onresize = () => {
        setTimeout(() => {
          const width = this.$refs.box.offsetWidth;
          const height = this.$refs.box.offsetHeight;

          ec.resize({
            width: width,
            height: height
          });
        }, 500);
      };
    }
  }
};


</script>
<style scoped lang="less">
.doh{
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  border-radius: 10px;
  padding-top: 10px;
  padding-left: 35px;
  box-sizing: border-box;
  h2{
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 31px;
    text-align: left;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
  }
}
.box {
  width: 360px;
  height: 180px;
}
</style>